import getWindow from "./window";

export function getIntlNumberFormat({ language, value, options }) {
  const numberFormat = getWindow().Intl.NumberFormat;
  return new numberFormat(language, options).format(value);
}
